module.exports = __webpack_public_path__ + "img/howto_ico03.e8045a8f.png";